var _defs, _path, _path2, _rect, _g, _path3, _path4, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnQ116(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3",
    "data-name": 3,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 53.461,
    viewBox: "0 0 65 53.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3735a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a3da"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M0,0H2.314V5.793H17.456V7.936H0Z",
    transform: "translate(11.703 40.782)",
    fill: "#e1f4fb",
    stroke: "#e1f4fb",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M.96,0H31.844a.96.96,0,0,1,.96.96V39.233a.96.96,0,0,1-.96.96H.96a.96.96,0,0,1-.96-.96V.96A.96.96,0,0,1,.96,0Z",
    transform: "translate(28.551 12.789)",
    fill: "#e1f4fb",
    stroke: "#e1f4fb",
    strokeMiterlimit: 10,
    strokeWidth: 0.96
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 26.121,
    height: 34.712,
    rx: 0.96,
    transform: "translate(32.196 15.833)",
    fill: "#fff",
    stroke: "#00a3da",
    strokeMiterlimit: 10,
    strokeWidth: 0.96
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flame",
    transform: "translate(40.705 37.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M1.869,11.287a8.757,8.757,0,0,1-1.5-2.123,4.824,4.824,0,0,1-.284-2.77A5.981,5.981,0,0,1,1.275,3.831a2.473,2.473,0,0,0,.62,1.812,4.314,4.314,0,0,1,.981-3.573A7.38,7.38,0,0,1,6.027,0a2.557,2.557,0,0,0-.439,2.433,10.156,10.156,0,0,0,1.162,2.3,5.15,5.15,0,0,1,.878,2.382,8.335,8.335,0,0,0,.646-1.372,2.717,2.717,0,0,0,.1-1.5A3.854,3.854,0,0,1,9.229,6.11a7.853,7.853,0,0,1,.026,2.2,5.513,5.513,0,0,1-.749,2.3A4.313,4.313,0,0,1,6.259,12.3,5.1,5.1,0,0,1,1.869,11.287Z",
    transform: "translate(0)",
    fill: "#f3705a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M1.706,7.016A2.546,2.546,0,0,0,4.753,3.391c0-.026-.026-.026-.026-.052a2.619,2.619,0,0,1-.646,2.278A2.423,2.423,0,0,0,3.85,3.65c-.31-.6-.749-1.139-1.085-1.709A2.757,2.757,0,0,1,2.326,0a3.415,3.415,0,0,0-1.24,1.916,3.473,3.473,0,0,0,.258,2.278,1.7,1.7,0,0,1-.7-1.243A2.67,2.67,0,0,0,0,4.737,2.636,2.636,0,0,0,1.706,7.016Z",
    transform: "translate(2.125 5.229)",
    fill: "#ffd15c"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-25.907,16.475H-54.862a3.03,3.03,0,0,1-3.025-3.029,3.03,3.03,0,0,1,3.025-3.029h17.539a.6.6,0,0,0,.6-.6.6.6,0,0,0-.6-.6H-54.571a3.322,3.322,0,0,1-3.316-3.321,3.322,3.322,0,0,1,3.316-3.321h17.189a.659.659,0,0,0,.656-.66.659.659,0,0,0-.656-.66H-66v-2.5h28.618a3.162,3.162,0,0,1,3.156,3.16,3.162,3.162,0,0,1-3.156,3.16H-54.571a.82.82,0,0,0-.816.821.82.82,0,0,0,.816.821h17.247a3.1,3.1,0,0,1,3.1,3.1,3.1,3.1,0,0,1-3.1,3.1H-54.862a.527.527,0,0,0-.525.529.527.527,0,0,0,.525.529h28.956Z",
    transform: "translate(90.907 20.705)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M6,0h9.262a6,6,0,0,1,6,6V36.02a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z",
    fill: "#e1f4fb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 16.402,
    height: 37.148,
    rx: 2,
    transform: "translate(2.43 2.436)",
    fill: "#fff",
    stroke: "#00a3da",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnQ116);
export default __webpack_public_path__ + "static/media/on_Q1_16_.1f4de86d60fb90d92aa0acdd91785433.svg";
export { ForwardRef as ReactComponent };